export interface ObjectHierarchicalMetadataValue {
  valueUri: string;
  textValue: string;
  isFreetext: false;
  breadcrumbs: string[];
}

export interface ObjectFreetextMetadataValue {
  textValue: string;
  isFreetext: true;
}

export type ObjectMetadataValue = ObjectHierarchicalMetadataValue | ObjectFreetextMetadataValue;

export const HIERARCHY_ROOT_IDS = {
  workTypes: 'aat:300191091', // Visual Works by Material (actual root used)
  materials: 'aat:300010358', // Materials (actual root used)
  techniques: 'aat:300053003', // Techniques (actual root used)
  substrates: 'aat:300010358'  // Same as materials (substrates are part of materials hierarchy)
} as const;

export type HierarchyType = keyof typeof HIERARCHY_ROOT_IDS;